//---------------- Common Text----------------------
export const TRANSLATIONS_ES = {
  

};
